import CreditsTableMobile from './CreditsTableMobile';

export default CreditsTableMobile;
